<template>
    <div>
        <b-card no-body v-if="mostrarMenu">
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - Relatórios</span>
                </h4>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-01')"
                                :href="`#/contratos/relatorios/planilhas/comprometimentossemregistropagamento`"
                                ><strong
                                    >Comprometimentos sem registro de
                                    pagamento</strong
                                >
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-02')"
                                :href="`#/contratos/relatorios/planilhas/relacaonotasfiscais`"
                                ><strong>Relação de Notas Fiscais</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-03')"
                                :href="`#/contratos/relatorios/planilhas/comprometimentosporcontrato`"
                                ><strong>Comprometimentos por Contrato</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-04')"
                                :href="`#/contratos/relatorios/planilhas/contratosporgestor`"
                                ><strong>Contratos por Gestor</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-05')"
                                :href="`#/contratos/relatorios/planilhas/valorespagosporcontratos`"
                                ><strong>Valores Pagos por Contratos</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-06')"
                                :href="`#/contratos/relatorios/planilhas/contratosanuais`"
                                ><strong>Contratos Anuais</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <div v-if="$temAcessoView('CONT-PNL-00')">
                    <h4 class="heading-1 mb-4">
                        <span>CONTRATOS - Painéis</span>
                    </h4>
                    <b-row class="mb-4">
                        <b-col lg="6" sm="12">
                            <b-list-group>
                                <b-list-group-item
                                    v-if="$temAcessoView('CONT-PNL-01')"
                                    :href="`#/contratos/relatorios/paineis/saldoanualcontratos`"
                                    >
                                    <strong>Saldo Anual dos Contratos</strong>
                                </b-list-group-item>
                            </b-list-group>
                        </b-col>
                    </b-row>
                </div>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    computed: {
        mostrarMenu() {
            return this.$route.name == 'Contratos_Relatorios'
        }
    }
}
</script>
